(function (Drupal, once) {
  Drupal.behaviors.flexiselect = {
    attach: function (context, settings) {
      once('selectList', '.js-form-item-select-list').forEach((element) => {
        // Select list

        const getSelectById = element.querySelector('.form-select');
        const getOptions = element.querySelectorAll('option');

        getSelectById.style.display = 'none';

        // Create new custom select list and populate

        const tag = document.createElement('div');
        tag.classList.add('custom-select-list');

        const selectListValue = document.createElement('div');
        selectListValue.classList.add('custom-select-list--value');

        const defaultInnerText = element.querySelector('.form-select option:first-child');
        const elementText = document.createTextNode(defaultInnerText.innerText);

        selectListValue.appendChild(elementText);
        element.appendChild(tag);
        tag.appendChild(selectListValue);

        // Create option container

        const optionContainer = document.createElement('div');
        optionContainer.classList.add('custom-select-list__container');

        tag.appendChild(optionContainer);

        // Populate select list with options

        getOptions.forEach((option) => {
          const getSelectContainer = element.querySelector(
            '.custom-select-list__container'
          );
          const optionText = document.createTextNode(option.innerText);
          const optionsTag = document.createElement('option');
          optionsTag.appendChild(optionText);
          optionsTag.value = option.value;
          optionsTag.classList.add('custom-select-list__container--option');

          getSelectContainer.appendChild(optionsTag);
        });

        // Custom select list dropdown logic

        const dropdownDiv = element.querySelector('.custom-select-list--value');
        const getCustomSelectDiv = element.querySelector('.custom-select-list');

        dropdownDiv.addEventListener('click', (event) => {
          getCustomSelectDiv.classList.toggle('select-opened');
        });

        const customOptions = element.querySelectorAll(
          '.custom-select-list .custom-select-list__container--option'
        );

        // Set value for the real select list

        customOptions.forEach((cOption) => {
          cOption.addEventListener('click', (event) => {
            getSelectById.value = event.target.value;
            element.querySelector('.custom-select-list--value').innerText =
              event.target.innerText;
            getCustomSelectDiv.classList.toggle('select-opened');
          });
        });
      });
    }
  };
})(Drupal, once);
